import init from './ambient-lights'
import stepperSlider from './stepper-slider'

// Index files are intended for importing and executing functions and classes only. They should not contain any logic.
import slider from './slider'
import ParallaxElement from './parallax'
import accordion from './accordion'
import newsletterForm from './newsletter-form'
import './subscription'
import footerSelector from './selector'
import doMitoqSubscription from './mitoq-subscription'
import cardTooltip from './card'
import blogCategoryFilters from './blog-category-filters'
import mitopureTransformation from './mitopure-transformation'
import './add-to-cart-loader'

const mitoqGlobalBootTs = performance.now()
const mitoqSubDebugEnabled =
  typeof window !== 'undefined' &&
  (window.__MITOQ_SUB_DEBUG__ === true ||
    new URLSearchParams(window.location.search).get('mitoqSubDebug') === '1')

const mitoqPerfLog = (message, meta = null) => {
  if (!mitoqSubDebugEnabled) return
  const elapsed = (performance.now() - mitoqGlobalBootTs).toFixed(1)

  if (meta) {
    console.log(`[MitoQGlobal][perf +${elapsed}ms] ${message}`, meta)
    return
  }

  console.log(`[MitoQGlobal][perf +${elapsed}ms] ${message}`)
}

function global() {
  // Register custom element as early as possible so parsed widgets can upgrade
  // without waiting for DOMContentLoaded.
  mitoqPerfLog('early doMitoqSubscription() call')
  doMitoqSubscription()

  document.addEventListener('DOMContentLoaded', function () {
    mitoqPerfLog('DOMContentLoaded fired', {
      readyState: document.readyState,
    })
    init()
    slider()
    accordion()
    newsletterForm()
    footerSelector()
    cardTooltip()
    blogCategoryFilters()
    mitopureTransformation()
    // Define the custom element
    customElements.define('parallax-element', ParallaxElement)
    stepperSlider()
  })
}

export default global
